module.exports = __webpack_public_path__ + "img/19f.a429b6e2.png";